import './PersonalAccountLayout.scss';
import React, {useContext, useEffect, useState} from 'react';
import block from 'bem-cn-lite';
import {Outlet} from 'react-router-dom';
import {FooterBlock, Header, NavigationBottomMenu} from '@components';
import {CApi as userGwApi} from '@services/api';
import {AppContext} from 'app/context';
import useIsTabActive from '@hooks/useIsTabActive';
import {tokenStorage} from '@app/token';
import {getBasket} from '@features/basket/services';
import {getBasketForStateUpdate} from '@features/basket/services/getBasketForStateUpdate';
import {isBasketLocation} from '@utils';
import {ordersFiltersStorage} from '@app/ordersFiltersStorage';
import {ordersSettingsStorage} from '@app/ordersSettingsStorage';
import {ErrorPage} from '@pages/ErrorPage';
import {ErrorBoundary} from '@components/ErrorBoundary';
import {useMediaQuery} from 'react-responsive';
import {useNavigationMenuVisibility, useOrdersRootOverflow} from '@hooks';
import {ordersReturnsFiltersStorage} from '@app/ordersReturnsFiltersStorage';
import {ordersReturnsSettingsStorage} from '@app/ordersReturnsSettingsStorage';

const b = block('personal-account-layout');

export const PersonalAccountLayout: React.FC = () => {
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const {style, isVisible} = useNavigationMenuVisibility();
    const {state, emit} = useContext(AppContext);
    const isTabActive = useIsTabActive();
    const storedOrdersFilters = ordersFiltersStorage.get();
    const storedOrdersSettings = ordersSettingsStorage.get();
    const storedOrdersReturnsFilters = ordersReturnsFiltersStorage.get();
    const storedOrdersReturnsSettings = ordersReturnsSettingsStorage.get();

    // Флаг ошибки в балансе, если бэк отдал null
    const [hasBalanceError, setHasBalanceError] = useState(false);

    // TODO: убрать временный костыль здесь и в глобал стилях
    // сделано для того, чтобы в фильтрах заказов не прыгал попап
    useOrdersRootOverflow();

    useEffect(() => {
        if (!isTabActive) return;
        loadClientDetails();
    }, [isTabActive]);

    useEffect(() => {
        loadClientDetails();

        // Если загружаем не страницу корзины, то обновим данные для шапки
        // На странице корзины этого делать не нужно, там уже есть обновление
        if (!isBasketLocation()) {
            getBasket().then(({items, itemsOut}) => {
                const basketState = getBasketForStateUpdate(items, itemsOut);
                emit('updateBasket', {
                    basket: {
                        ...basketState,
                        items: items,
                        itemsOut: itemsOut
                    }
                });
            });
        }

        //Обновим контекст, загрузим сохранены настройки из стора
        //Восстанавливаем состояние колонок в таблицы на странице заказов
        if (storedOrdersSettings) {
            emit('updateOrdersConfig', {
                config: storedOrdersSettings
            });
        }

        //Восстанавливаем состояние колонок в таблицы на странице возвратов заказов
        if (storedOrdersReturnsSettings) {
            emit('updateOrdersReturnsConfig', {
                returnsConfig: storedOrdersReturnsSettings
            });
        }

        //Восстанавливаем состояние фильтров на странице заказов
        if (storedOrdersFilters) {
            emit('updateOrders', {
                ...state,
                orders: {
                    filters: storedOrdersFilters
                }
            });
        }

        //Восстанавливаем состояние фильтров на странице возвратов заказов
        if (storedOrdersReturnsFilters) {
            emit('updateOrders', {
                ...state,
                orders: {
                    filtersReturns: storedOrdersReturnsFilters
                }
            });
        }
    }, []);

    function emitLoginEventIfTokenChanged() {
        const lsToken = tokenStorage.get();
        if (state.token !== lsToken) {
            window.location.reload();
        }
    }

    function loadClientDetails() {
        emitLoginEventIfTokenChanged();

        if (state?.user?.login) {
            userGwApi()
                .client.clientDetail(state.user.client)
                .then((response) => {
                    emit('updateClientDetails', {clientDetails: response.data});

                    // проверяем баланс после ответа
                    setHasBalanceError(response.data.balance == null);
                })
                .catch((error) => {
                    console.error('Ошибка при получении данных клиента:', error);
                });
        }
    }

    return (
        <div className={b()}>
            <Header />

            <div className={b('content')} id="main-content" tabIndex={-1}>
                <ErrorBoundary>
                    {hasBalanceError ? (
                        <ErrorPage errorCode={500} />
                    ) : (
                        <Outlet context={{isBottomMenuVisible: isVisible}} />
                    )}
                </ErrorBoundary>
            </div>

            <FooterBlock isMinimal />

            {isSmallScreen && (
                <div style={style}>
                    <NavigationBottomMenu />
                </div>
            )}
        </div>
    );
};
